import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	Pedestrismo,
	PedestrismoBackup
} from '../constants/enums';

import {
	Button,
	Glyphicon
} from '../../node_modules/react-bootstrap/lib/';

import '../css/App.css';


const MIN_TIMELINE_SECONDS = 60;


class ParticipantVisualization extends Component {

	constructor(props) {
		super(props);

		this.state = {

			hasSnapshot: false,

			snapshotParticipants: [],

			snapshotStartedAt: 0,

			snapshotCompetition: 0,

			snapshotDistanceConfigs: []
		};


		this.handleRefreshVisualization =
			this.handleRefreshVisualization.bind(this);

		this.usesCategoryStartOffsets =
			this.usesCategoryStartOffsets.bind(this);

		this.getDistanceConfigs =
			this.getDistanceConfigs.bind(this);

		this.getParticipantDistanceConfig =
			this.getParticipantDistanceConfig.bind(this);

		this.getParticipantTimelineData =
			this.getParticipantTimelineData.bind(this);

		this.formatTime =
			this.formatTime.bind(this);
	}


	/*
	 * -------------------------------------------------------
	 * ACTUALIZAR VISUALIZACION
	 * -------------------------------------------------------
	 */
	handleRefreshVisualization() {

		const distanceConfigs =
			this.getDistanceConfigs();


		const snapshotParticipants =
			this.props.participantList.map(
				(participant) => ({
					...participant
				})
			);


		this.setState({

			hasSnapshot:
				true,

			snapshotParticipants,

			snapshotStartedAt:
				Number(
					this.props.startedAt || 0
				),

			snapshotCompetition:
				Number(
					this.props.competition || 0
				),

			snapshotDistanceConfigs:
				distanceConfigs.map(
					(config) => ({
						...config
					})
				)
		});
	}


	/*
	 * -------------------------------------------------------
	 * TIPO DE CONFIGURACION DE LARGADA
	 * -------------------------------------------------------
	 *
	 * Pedestrismo:
	 * largadas por distancia.
	 *
	 * Triatlón / Duatlón / Rural Bike-MTB:
	 * largadas por categoría.
	 */
	usesCategoryStartOffsets(
		competition = this.props.competition
	) {

		const value =
			Number(
				competition || 0
			);


		return (
			value !== 0 &&
			value !== Number(
				Pedestrismo
			) &&
			value !== Number(
				PedestrismoBackup
			)
		);
	}


	/*
	 * -------------------------------------------------------
	 * CONFIGURACION ACTUAL DE LARGADAS
	 * -------------------------------------------------------
	 *
	 * Se conserva el nombre getDistanceConfigs
	 * para no modificar innecesariamente
	 * el resto del componente.
	 *
	 * Sin embargo ahora devuelve:
	 *
	 * - Pedestrismo:
	 *   configuraciones por distancia.
	 *
	 * - Triatlón / Duatlón / Rural Bike:
	 *   configuraciones por catCod.
	 */
getDistanceConfigs() {

	const competition =
		Number(
			this.props.competition || 0
		);


	/*
	 * ===================================================
	 * LARGADAS POR CATEGORIA
	 * ===================================================
	 *
	 * Triatlón / Duatlón / Rural Bike-MTB.
	 */
	if (
		this.usesCategoryStartOffsets(
			competition
		)
	) {

		const configuredOffsets =
			Array.isArray(
				this.props.categoryStartOffsets
			)
				? this.props.categoryStartOffsets
				: [];


		let categoryConfigs =
			configuredOffsets

				.filter(
					(config) =>
						String(
							config.catCod || ''
						).trim() !== ''
				)

				.map(
					(config, index) => ({

						slot:
							index + 1,

						type:
							'category',

						catCod:
							String(
								config.catCod || ''
							).trim(),

						catName:
							String(
								config.catName ||
								config.catCod ||
								''
							).trim(),

						offset:
							Number(
								config.offset || 0
							)
					})
				);


		/*
		 * FALLBACK:
		 * Si no existen offsets configurados,
		 * obtenemos las categorías desde los atletas.
		 */
		if (
			categoryConfigs.length === 0
		) {

			const categoryMap =
				new Map();


			(
				this.props.participantList ||
				[]
			).forEach(
				(participant) => {

					const catCod =
						String(
							participant.catCod || ''
						).trim();


					const catName =
						String(
							participant.catName ||
							catCod
						).trim();


					if (
						catCod === ''
					) {

						return;
					}


					if (
						!categoryMap.has(
							catCod
						)
					) {

						categoryMap.set(
							catCod,
							{
								catCod,
								catName
							}
						);
					}
				}
			);


			categoryConfigs =
				Array.from(
					categoryMap.values()
				)
					.map(
						(category, index) => ({

							slot:
								index + 1,

							type:
								'category',

							catCod:
								category.catCod,

							catName:
								category.catName,

							offset:
								0
						})
					);
		}


		categoryConfigs.sort(
			(a, b) => {

				if (
					a.offset !== b.offset
				) {

					return (
						a.offset -
						b.offset
					);
				}


				return String(
					a.catCod
				).localeCompare(
					String(
						b.catCod
					),
					'es',
					{
						numeric: true,
						sensitivity: 'base'
					}
				);
			}
		);


		const uniqueOffsets = [];


		categoryConfigs.forEach(
			(config) => {

				if (
					!uniqueOffsets.includes(
						config.offset
					)
				) {

					uniqueOffsets.push(
						config.offset
					);
				}
			}
		);


		return categoryConfigs.map(
			(config) => {

				const timeIndex =
					uniqueOffsets.indexOf(
						config.offset
					);


				return {

					...config,

					/*
					 * En MTB / Triatlón / Duatlón
					 * mantenemos el color asociado
					 * a la largada.
					 */
					slot:
						timeIndex + 1,

					colorSlot:
						timeIndex + 1,

					timeIndex,

					timeLabel:
						'T' +
						timeIndex,

					label:
						config.catName ||
						config.catCod
				};
			}
		);
	}


	/*
	 * ===================================================
	 * PEDESTRISMO
	 * ===================================================
	 *
	 * La largada se agrupa por offset,
	 * pero el COLOR identifica la distancia.
	 */
	const configs = [
		{
			slot: 1,

			type:
				'distance',

			distance:
				String(
					this.props.distance1Type || ''
				).trim(),

			offset:
				Number(
					this.props.distance1StartOffset || 0
				)
		},

		{
			slot: 2,

			type:
				'distance',

			distance:
				String(
					this.props.distance2Type || ''
				).trim(),

			offset:
				Number(
					this.props.distance2StartOffset || 0
				)
		},

		{
			slot: 3,

			type:
				'distance',

			distance:
				String(
					this.props.distance3Type || ''
				).trim(),

			offset:
				Number(
					this.props.distance3StartOffset || 0
				)
		}
	]
		.filter(
			(config) =>
				config.distance !== ''
		);


	configs.sort(
		(a, b) => {

			if (
				a.offset !== b.offset
			) {

				return (
					a.offset -
						b.offset
				);
			}


			return (
				a.slot -
					b.slot
			);
		}
	);


	const uniqueOffsets = [];


	configs.forEach(
		(config) => {

			if (
				!uniqueOffsets.includes(
					config.offset
				)
			) {

				uniqueOffsets.push(
					config.offset
				);
			}
		}
	);


	return configs.map(
		(config) => {

			const timeIndex =
				uniqueOffsets.indexOf(
					config.offset
				);


			return {

				...config,

				/*
				 * slot identifica la LARGADA.
				 *
				 * 5K y 10K pueden compartir T0.
				 */
				slot:
					timeIndex + 1,

				/*
				 * colorSlot identifica la DISTANCIA.
				 *
				 * Se conserva el slot original:
				 * distance1 = color 1
				 * distance2 = color 2
				 * distance3 = color 3
				 */
				colorSlot:
					config.slot,

				timeIndex,

				timeLabel:
					'T' +
						timeIndex,

				label:
					config.distance +
						'K'
			};
		}
	);
}



	getBaseOffsetMinutes(
		distanceConfigs
	) {

		if (
			!distanceConfigs ||
			distanceConfigs.length === 0
		) {

			return 0;
		}


		return Math.min(
			...distanceConfigs.map(
				(config) =>
					config.offset
			)
		);
	}


	/*
	 * -------------------------------------------------------
	 * CONFIGURACION DE LARGADA DEL PARTICIPANTE
	 * -------------------------------------------------------
	 */
	getParticipantDistanceConfig(
		participant,
		distanceConfigs
	) {

		if (
			!participant ||
			!distanceConfigs ||
			distanceConfigs.length === 0
		) {

			return null;
		}


		const competition =
			Number(
				this.state.snapshotCompetition ||
				this.props.competition ||
				0
			);


		/*
		 * ===================================================
		 * TRIATLON / DUATLON / RURAL BIKE-MTB
		 * ===================================================
		 *
		 * Buscamos por catCod.
		 */
		if (
			this.usesCategoryStartOffsets(
				competition
			)
		) {

			const participantCatCod =
				String(
					participant.catCod || ''
				).trim();


			if (
				participantCatCod === ''
			) {

				return null;
			}


			return (
				distanceConfigs.find(
					(config) =>
						String(
							config.catCod || ''
						).trim() ===
						participantCatCod
				)
				||
				null
			);
		}


		/*
		 * ===================================================
		 * PEDESTRISMO
		 * ===================================================
		 *
		 * Buscamos por distancia.
		 */
		const participantDistance =
			String(
				participant.distance || ''
			).trim();


		return (
			distanceConfigs.find(
				(config) =>
					config.distance ===
						participantDistance
			)
			||
			null
		);
	}


	/*
	 * -------------------------------------------------------
	 * DATOS TEMPORALES DEL ATLETA
	 * -------------------------------------------------------
	 */
	getParticipantTimelineData(
		participant,
		distanceConfigs,
		baseOffset
	) {

		const distanceConfig =
			this.getParticipantDistanceConfig(
				participant,
				distanceConfigs
			);


		if (
			!distanceConfig
		) {

			return null;
		}


		const startedAt =
			Number(
				this.state.snapshotStartedAt || 0
			);


		if (
			startedAt <= 0
		) {

			return null;
		}


		/*
		 * El comienzo de la línea del atleta
		 * depende del offset de su largada.
		 */
		const startSeconds =
			Math.max(
				0,

				(
					distanceConfig.offset -
					baseOffset
				) *
				60
			);


		const registeredTime =
			Number(
				participant.registeredTime1 || 0
			);


		const registered =
			registeredTime > 0;


		const dns =
			Number(
				participant.dns || 0
			) > 0;


		const disqualified =
			Number(
				participant.disqualified || 0
			) > 0;


		let raceTimeSeconds = 0;

		let finishSeconds = null;

		const dnf =
			Number(
				participant.dnf || 0
			) > 0;


		if (
			registered
		) {

			/*
			* Momento absoluto de llegada tomando
			* como T0 el inicio general del evento.
			*
			* Ejemplo:
			*
			* startedAt      = 00:00
			* largada atleta = 05:00
			* llegada        = 15:00
			*
			* absoluteFinishSeconds = 15:00
			*/
			const absoluteFinishSeconds =
				Math.max(
					0,

					(
						registeredTime -
						startedAt
					) /
						1000
				);


			/*
			* Tiempo neto de competencia.
			*
			* Si largó en 05:00 y llegó en 15:00:
			*
			* 15:00 - 05:00 = 10:00
			*/
			raceTimeSeconds =
				Math.max(
					0,

					absoluteFinishSeconds -
						startSeconds
				);


			/*
			* La bandera debe posicionarse sobre
			* el momento ABSOLUTO de llegada.
			*
			* NO debemos volver a sumar startSeconds.
			*/
			finishSeconds =
				absoluteFinishSeconds;
		}


		return {

			distanceConfig,

			startSeconds,

			raceTimeSeconds,

			finishSeconds,

			registered,

			dnf,

			dns,

			disqualified
		};
	}


	formatTime(seconds) {

		const safeSeconds =
			Math.max(
				0,
				Number(
					seconds || 0
				)
			);


		const totalSeconds =
			Math.floor(
				safeSeconds
			);


		const hours =
			Math.floor(
				totalSeconds /
				3600
			);


		const minutes =
			Math.floor(
				(
					totalSeconds %
					3600
				) /
				60
			);


		const secs =
			totalSeconds %
			60;


		if (
			hours > 0
		) {

			return (
				String(hours)
					.padStart(
						2,
						'0'
					)
				+
				':' +
				String(minutes)
					.padStart(
						2,
						'0'
					)
				+
				':' +
				String(secs)
					.padStart(
						2,
						'0'
					)
			);
		}


		return (
			String(minutes)
				.padStart(
					2,
					'0'
				)
			+
			':' +
			String(secs)
				.padStart(
					2,
					'0'
				)
		);
	}


getDistanceColor(slot) {

	const colors = [

		'#337ab7', // azul
		'#20a8ad', // turquesa
		'#5cb85c', // verde
		'#f0ad4e', // naranja
		'#d9534f', // rojo
		'#8e44ad', // violeta
		'#2c3e50', // azul oscuro
		'#e67e22', // naranja oscuro
		'#16a085', // verde agua
		'#c0392b', // rojo oscuro
		'#7f8c8d', // gris azulado
		'#2980b9', // azul intenso
		'#27ae60', // verde intenso
		'#9b59b6', // púrpura
		'#d35400', // naranja fuerte
		'#34495e', // slate
		'#1abc9c', // turquesa claro
		'#e74c3c', // rojo claro
		'#6c5ce7', // violeta azulado
		'#00a8ff'  // celeste
	];


	const index =
		Math.max(
			0,
			Number(slot || 1) - 1
		);


	/*
	 * Tenemos una paleta inicial de 20 colores.
	 */
	if (
		index < colors.length
	) {

		return colors[index];
	}


	/*
	 * Si excepcionalmente hay más de
	 * 20 categorías generamos automáticamente
	 * un color utilizando HSL.
	 *
	 * Así nunca volvemos al gris genérico.
	 */
	const hue =
		(
			index *
			137.508
		) %
		360;


	return (
		'hsl(' +
		Math.round(hue) +
		', 65%, 45%)'
	);
}


	getTimelineMarks(
		maxSeconds
	) {

		maxSeconds =
			Math.max(
				MIN_TIMELINE_SECONDS,
				maxSeconds
			);


		const marksCount = 6;


		const rawStep =
			maxSeconds /
			marksCount;


		let step;


		if (
			rawStep <= 10
		) {

			step = 10;

		} else if (
			rawStep <= 30
		) {

			step = 30;

		} else if (
			rawStep <= 60
		) {

			step = 60;

		} else if (
			rawStep <= 120
		) {

			step = 120;

		} else if (
			rawStep <= 300
		) {

			step = 300;

		} else if (
			rawStep <= 600
		) {

			step = 600;

		} else if (
			rawStep <= 900
		) {

			step = 900;

		} else if (
			rawStep <= 1800
		) {

			step = 1800;

		} else {

			step = 3600;
		}


		const axisMax =
			Math.ceil(
				maxSeconds /
				step
			) *
			step;


		const marks = [];


		for (
			let seconds = 0;
			seconds <= axisMax;
			seconds += step
		) {

			marks.push(
				seconds
			);
		}


		return {
			marks,
			axisMax
		};
	}


	renderTimeScale(
		axisMax,
		marks
	) {

		return (

			<div
				style={{
					position:
						'relative',

					height:
						'28px',

					marginLeft:
						'260px',

					marginRight:
						'80px'
				}}
			>

				{
					marks.map(
						(seconds) => {

							const left =
								seconds /
								axisMax *
								100;


							return (

								<div
									key={
										'scale-' +
										seconds
									}
									style={{
										position:
											'absolute',

										left:
											left +
											'%',

										transform:
											'translateX(-50%)',

										fontSize:
											'11px',

										color:
											'#666'
									}}
								>

									{
										this.formatTime(
											seconds
										)
									}

								</div>
							);
						}
					)
				}

			</div>
		);
	}


	renderGlobalGridLines(
		axisMax,
		marks
	) {

		return (

			<div
				style={{
					position:
						'absolute',

					left:
						'260px',

					right:
						'80px',

					top: 0,

					bottom: 0,

					pointerEvents:
						'none',

					zIndex: 0
				}}
			>

				{
					marks.map(
						(seconds) => {

							const left =
								seconds /
								axisMax *
								100;


							return (

								<div
									key={
										'grid-' +
										seconds
									}
									style={{
										position:
											'absolute',

										left:
											left +
											'%',

										top: 0,

										bottom: 0,

										borderLeft:
											'1px dashed #ddd'
									}}
								/>
							);
						}
					)
				}

			</div>
		);
	}


	/*
	 * -------------------------------------------------------
	 * MARCADORES DE LARGADA
	 * -------------------------------------------------------
	 *
	 * Agrupamos por offset para evitar mostrar
	 * varios marcadores exactamente superpuestos
	 * cuando varias categorías largan juntas.
	 */
renderStartMarkers(
	axisMax,
	distanceConfigs,
	baseOffset
) {

	const groupedStarts =
		[];


	distanceConfigs.forEach(
		(config) => {

			let group =
				groupedStarts.find(
					(item) =>
						item.offset ===
						config.offset
				);


			if (
				!group
			) {

				group = {

					offset:
						config.offset,

					slot:
						config.slot,

					timeLabel:
						config.timeLabel,

					items:
						[]
				};


				groupedStarts.push(
					group
				);
			}


			const color =
				this.getDistanceColor(
					config.colorSlot ||
					config.slot
				);


			const label =
				config.label || '';


			if (
				label !== '' &&
				!group.items.some(
					(item) =>
						item.label === label
				)
			) {

				group.items.push({
					label,
					color
				});
			}
		}
	);


	return groupedStarts.map(
		(group) => {

			const startSeconds =
				(
					group.offset -
						baseOffset
				) *
				60;


			const left =
				startSeconds /
					axisMax *
					100;


			const mainColor =
				group.items.length > 0
					? group.items[0].color
					: this.getDistanceColor(
						group.slot
					);


			return (

				<div
					key={
						'start-' +
						group.timeLabel
					}

					style={{
						position:
							'absolute',

						left:
							left +
							'%',

						top:
							'-58px',

						transform:
							'translateX(-50%)',

						border:
							'1px solid ' +
								mainColor,

						background:
							'#fff',

						padding:
							'4px 7px',

						borderRadius:
							'4px',

						fontSize:
							'11px',

						fontWeight:
							'bold',

						whiteSpace:
							'nowrap',

						zIndex:
							5
					}}
				>

					<span
						style={{
							color:
								mainColor
						}}
					>
						{
							group.timeLabel
						}
					</span>


					{
						group.items.length > 0 &&
						<span>
							{' - '}

							{
								group.items.map(
									(item, index) => (

										<span
											key={
												group.timeLabel +
												'-' +
												item.label
											}

											style={{
												color:
													item.color
											}}
										>

											{
												index > 0
													? ' / '
													: ''
											}

											{
												item.label
											}

										</span>
									)
								)
							}

						</span>
					}


					<br />


					<span
						style={{
							color:
								'#333'
						}}
					>
						{
							this.formatTime(
								startSeconds
							)
						}
					</span>

				</div>
			);
		}
	);
}


renderParticipantRow(
	item,
	index,
	axisMax
) {

	const participant =
		item.participant;


	const timeline =
		item.timeline;


	const {
		distanceConfig,
		startSeconds,
		raceTimeSeconds,
		finishSeconds,
		registered,
		dns,
		disqualified
	} = timeline;


	const startPercent =
		startSeconds /
			axisMax *
			100;


	const finishPercent =
		registered
			? finishSeconds /
				axisMax *
				100
			: startPercent;


	const widthPercent =
		registered
			? Math.max(
				0,
				finishPercent -
					startPercent
			)
			: 0;


	/*
	 * IMPORTANTE:
	 *
	 * colorSlot identifica la distancia.
	 *
	 * slot identifica la largada.
	 *
	 * En versiones anteriores se utilizaba
	 * solamente slot, por eso 5K y 10K
	 * compartían color cuando ambos eran T0.
	 */
	const color =
		this.getDistanceColor(
			distanceConfig.colorSlot ||
			distanceConfig.slot
		);


	return (

		<div
			key={
				String(
					participant.id
				) +
					'-' +
					String(
						participant.number
					) +
					'-' +
					index
			}

			style={{
				display:
					'flex',

				alignItems:
					'center',

				minHeight:
					'26px',

				borderBottom:
					'1px solid #f1f1f1',

				position:
					'relative',

				zIndex:
					1
			}}
		>

			<div
				style={{
					width:
						'70px',

					paddingRight:
						'8px',

					textAlign:
						'right',

					fontWeight:
						'bold',

					fontSize:
						'11px',

					flexShrink:
						0
				}}
			>

				{
					participant.number
				}

			</div>


			<div
				style={{
					width:
						'170px',

					padding:
						'0 10px',

					overflow:
						'hidden',

					whiteSpace:
						'nowrap',

					textOverflow:
						'ellipsis',

					fontSize:
						'11px',

					flexShrink:
						0
				}}

				title={
					participant.fullname
				}
			>

				{
					participant.fullname
				}

			</div>


			<div
				style={{
					position:
						'relative',

					height:
						'14px',

					flex:
						1
				}}
			>

				{
					registered &&
						!disqualified &&
						!dns &&
						<div
							style={{
								position:
									'absolute',

								left:
									startPercent +
										'%',

								width:
									widthPercent +
										'%',

								top:
									'3px',

								height:
									'8px',

								background:
									color,

								zIndex:
									2
							}}
						/>
				}


				{
					registered &&
						!disqualified &&
						!dns &&
						<div
							title={
								'Tiempo: ' +
								this.formatTime(
									raceTimeSeconds
								)
							}

							style={{
								position:
									'absolute',

								left:
									finishPercent +
										'%',

								top:
									'-4px',

								transform:
									'translateX(-50%)',

								zIndex:
									4,

								fontSize:
									'13px'
							}}
						>

							🏁

						</div>
				}


				{
					dns &&
						<div
							style={{
								position:
									'absolute',

								left:
									startPercent +
										'%',

								top:
									'0',

								fontSize:
									'10px',

								fontWeight:
									'bold',

								color:
									'#f0ad4e'
							}}
						>

							DNS

						</div>
				}


				{
					disqualified &&
						<div
							style={{
								position:
									'absolute',

								left:
									startPercent +
										'%',

								top:
									'0',

								fontSize:
									'10px',

								fontWeight:
									'bold',

								color:
									'#d9534f'
							}}
						>

							DSQ

						</div>
				}

			</div>


			<div
				style={{
					width:
						'80px',

					paddingLeft:
						'8px',

					fontSize:
						'11px',

					fontWeight:
						dns ||
						disqualified
							? 'bold'
							: 'normal',

					color:
						dns
							? '#f0ad4e'
							: (
								disqualified
									? '#d9534f'
									: '#333'
							),

					flexShrink:
						0
				}}
			>

				{
					dns
						? 'DNS'
						: (
							disqualified
								? 'DSQ'
								: (
									registered
										? this.formatTime(
											raceTimeSeconds
										)
										: ''
								)
						)
				}

			</div>

		</div>
	);
}

	/*
	 * -------------------------------------------------------
	 * RESUMEN DE LARGADAS
	 * -------------------------------------------------------
	 *
	 * También agrupamos categorías que tienen
	 * el mismo offset.
	 */
renderDistanceSummary(
	distanceConfigs,
	baseOffset
) {

	if (
		distanceConfigs.length === 0
	) {

		return null;
	}


	const groupedStarts =
		[];


	distanceConfigs.forEach(
		(config) => {

			let group =
				groupedStarts.find(
					(item) =>
						item.offset ===
						config.offset
				);


			if (
				!group
			) {

				group = {

					offset:
						config.offset,

					slot:
						config.slot,

					timeLabel:
						config.timeLabel,

					items:
						[]
				};


				groupedStarts.push(
					group
				);
			}


			const color =
				this.getDistanceColor(
					config.colorSlot ||
					config.slot
				);


			const label =
				config.label || '';


			if (
				label !== '' &&
				!group.items.some(
					(item) =>
						item.label === label
				)
			) {

				group.items.push({
					label,
					color
				});
			}
		}
	);


	return (

		<div
			style={{
				padding:
					'10px 15px',

				marginBottom:
					'15px',

				border:
					'1px solid #ddd',

				borderRadius:
					'4px',

				background:
					'#fafafa'
			}}
		>

			<strong>
				Largadas:
			</strong>

			{' '}


			{
				groupedStarts.map(
					(group) => {

						const seconds =
							(
								group.offset -
									baseOffset
							) *
								60;


						return (

							<span
								key={
									group.timeLabel
								}

								style={{
									marginRight:
										'22px',

									display:
										'inline-block'
								}}
							>

								{
									group.items.map(
										(item, index) => (

											<React.Fragment
												key={
													group.timeLabel +
													'-' +
													item.label
												}
											>

												{
													index > 0 &&
													<span>
														{' / '}
													</span>
												}


												<span
													style={{
														display:
															'inline-block',

														width:
															'10px',

														height:
															'10px',

														borderRadius:
															'50%',

														background:
															item.color,

														marginRight:
															'5px',

														marginLeft:
															index > 0
																? '4px'
																: '0'
													}}
												/>


												<span
													style={{
														color:
															item.color,

														fontWeight:
															'bold'
													}}
												>
													{
														item.label
													}
												</span>

											</React.Fragment>
										)
									)
								}


								{': '}

								{
									group.timeLabel
								}

								{' = '}

								{
									this.formatTime(
										seconds
									)
								}

							</span>
						);
					}
				)
			}

		</div>
	);
}

	render() {

		/*
		 * DATOS EN VIVO.
		 *
		 * Contamos llegadas + DNS + DSQ para saber
		 * si el snapshot quedó desactualizado.
		 */
		const currentResolvedCount =
			this.props.participantList.reduce(
				(total, participant) => {

					const registered =
						Number(
							participant.registeredTime1 || 0
						) > 0;


					const dns =
						Number(
							participant.dns || 0
						) > 0;


					const dsq =
						Number(
							participant.disqualified || 0
						) > 0;


					return (
						total +
						(
							registered ||
							dns ||
							dsq
								? 1
								: 0
						)
					);
				},
				0
			);


		const currentRegisteredCount =
			this.props.participantList.reduce(
				(total, participant) => {

					return (
						total +
						(
							Number(
								participant.registeredTime1 || 0
							) > 0
								? 1
								: 0
						)
					);
				},
				0
			);


		if (
			!this.state.hasSnapshot
		) {

			return (

				<div
					className="container-fluid"
				>

					<h3>
						<p align="center">
							<strong>
								Visualización
							</strong>
						</p>
					</h3>


					<div
						style={{
							textAlign:
								'center',

							marginBottom:
								'20px'
						}}
					>

						<Button
							bsStyle="primary"
							onClick={
								this.handleRefreshVisualization
							}
						>

							<Glyphicon
								glyph="refresh"
							/>

							{' '}

							Actualizar visualización

						</Button>

					</div>


					<div
						className="alert alert-info"
					>

						Llegadas actuales:

						{' '}

						<strong>
							{
								currentRegisteredCount
							}
						</strong>

						{' / '}

						{
							this.props.participantList.length
						}

						<br />

						Estados resueltos:

						{' '}

						<strong>
							{
								currentResolvedCount
							}
						</strong>

						{' / '}

						{
							this.props.participantList.length
						}

						<br />

						Presione Actualizar visualización
						para generar el gráfico.

					</div>

				</div>
			);
		}


		const snapshotParticipants =
			this.state.snapshotParticipants;


		const distanceConfigs =
			this.state.snapshotDistanceConfigs;


		const baseOffset =
			this.getBaseOffsetMinutes(
				distanceConfigs
			);


		const visibleParticipants = [];


		let maxSeconds =
			MIN_TIMELINE_SECONDS;


		snapshotParticipants.forEach(
			(participant) => {

				const registered =
					Number(
						participant.registeredTime1 || 0
					) > 0;


				const dns =
					Number(
						participant.dns || 0
					) > 0;


				const disqualified =
					Number(
						participant.disqualified || 0
					) > 0;


				if (
					!registered &&
					!dns &&
					!disqualified
				) {

					return;
				}


				const timeline =
					this.getParticipantTimelineData(
						participant,
						distanceConfigs,
						baseOffset
					);


				if (
					!timeline
				) {

					return;
				}


				if (
					timeline.finishSeconds !== null
				) {

					maxSeconds =
						Math.max(
							maxSeconds,
							timeline.finishSeconds
						);
				}


				visibleParticipants.push({
					participant,
					timeline
				});
			}
		);


		/*
 * -------------------------------------------------------
 * ORDEN DE VISUALIZACION
 * -------------------------------------------------------
 *
 * 1. Llegadas válidas por TIEMPO NETO.
 * 2. DNF.
 * 3. DSQ.
 * 4. DNS.
 *
 * IMPORTANTE:
 *
 * No ordenamos por startSeconds ni por finishSeconds.
 *
 * startSeconds:
 *   indica cuándo largó el atleta.
 *
 * finishSeconds:
 *   indica el momento absoluto de llegada.
 *
 * raceTimeSeconds:
 *   representa el tiempo NETO real de competencia:
 *
 *   llegada - offset de largada.
 */
visibleParticipants.sort(
	(a, b) => {

		const aRegistered =
			a.timeline.registered &&
			!a.timeline.dnf &&
			!a.timeline.disqualified &&
			!a.timeline.dns;


		const bRegistered =
			b.timeline.registered &&
			!b.timeline.dnf &&
			!b.timeline.disqualified &&
			!b.timeline.dns;


		/*
		 * Ambos tienen una llegada válida.
		 *
		 * Ordenamos por TIEMPO NETO.
		 */
		if (
			aRegistered &&
			bRegistered
		) {

			if (
				a.timeline.raceTimeSeconds !==
				b.timeline.raceTimeSeconds
			) {

				return (
					a.timeline.raceTimeSeconds -
					b.timeline.raceTimeSeconds
				);
			}


			/*
			 * Empate:
			 * ordenamos por dorsal.
			 */
			return (
				Number(
					a.participant.number || 0
				) -
				Number(
					b.participant.number || 0
				)
			);
		}


		/*
		 * Una llegada válida siempre aparece
		 * antes que un estado especial.
		 */
		if (
			aRegistered !==
			bRegistered
		) {

			return aRegistered
				? -1
				: 1;
		}


		/*
		 * Estados especiales:
		 *
		 * DNF
		 * DSQ
		 * DNS
		 */
		const getStatusPriority =
			(item) => {

				if (
					item.timeline.dnf
				) {

					return 1;
				}


				if (
					item.timeline.disqualified
				) {

					return 2;
				}


				if (
					item.timeline.dns
				) {

					return 3;
				}


				return 99;
			};


		const priorityA =
			getStatusPriority(a);


		const priorityB =
			getStatusPriority(b);


		if (
			priorityA !==
			priorityB
		) {

			return (
				priorityA -
				priorityB
			);
		}


		/*
		 * Dentro del mismo estado especial
		 * ordenamos por dorsal.
		 */
		return (
			Number(
				a.participant.number || 0
			) -
			Number(
				b.participant.number || 0
			)
		);
	}
);

		maxSeconds =
			maxSeconds *
			1.05;


		const {
			marks,
			axisMax
		} =
			this.getTimelineMarks(
				maxSeconds
			);


		const snapshotRegisteredCount =
			visibleParticipants.filter(
				(item) =>
					item.timeline.registered &&
					!item.timeline.disqualified &&
					!item.timeline.dns
			).length;


		const snapshotResolvedCount =
			visibleParticipants.length;


		const hasNewResults =
			currentResolvedCount !==
			snapshotResolvedCount;


		return (

			<div
				className="container-fluid"
			>

				<h3>
					<p align="center">
						<strong>
							Visualización
						</strong>
					</p>
				</h3>


				<div
					style={{
						textAlign:
							'center',

						marginBottom:
							'15px'
					}}
				>

					<Button
						bsStyle={
							hasNewResults
								? 'warning'
								: 'primary'
						}
						onClick={
							this.handleRefreshVisualization
						}
					>

						<Glyphicon
							glyph="refresh"
						/>

						{' '}

						Actualizar visualización

					</Button>

				</div>


				<div
					style={{
						textAlign:
							'center',

						marginBottom:
							'15px',

						fontSize:
							'12px'
					}}
				>

					Mostradas:

					{' '}

					<strong>
						{
							snapshotResolvedCount
						}
					</strong>

					{' | '}

					Llegadas mostradas:

					{' '}

					<strong>
						{
							snapshotRegisteredCount
						}
					</strong>

					{' | '}

					Estados actuales:

					{' '}

					<strong>
						{
							currentResolvedCount
						}
					</strong>


					{
						hasNewResults &&
						<span
							style={{
								marginLeft:
									'10px',

								color:
									'#f0ad4e',

								fontWeight:
									'bold'
							}}
						>

							Hay cambios pendientes

						</span>
					}

				</div>


				{
					this.renderDistanceSummary(
						distanceConfigs,
						baseOffset
					)
				}


				{
					visibleParticipants.length === 0
						? (

							<div
								className="alert alert-info"
							>
								No había llegadas, DNS ni DSQ
								al momento de actualizar.
							</div>

						)
						: (

							<div
								style={{
									border:
										'1px solid #ddd',

									borderRadius:
										'4px',

									padding:
										'20px',

									background:
										'#fff',

									overflowX:
										'auto'
								}}
							>

								<div
									style={{
										minWidth:
											'900px'
									}}
								>

									<div
										style={{
											display:
												'flex',

											marginTop:
												'65px'
										}}
									>

										<div
											style={{
												width:
													'70px',

												textAlign:
													'right',

												paddingRight:
													'8px',

												fontWeight:
													'bold',

												fontSize:
													'11px',

												flexShrink:
													0
											}}
										>

											Dorsal

										</div>


										<div
											style={{
												width:
													'170px',

												padding:
													'0 10px',

												fontWeight:
													'bold',

												fontSize:
													'11px',

												flexShrink:
													0
											}}
										>

											Atleta

										</div>


										<div
											style={{
												position:
													'relative',

												flex:
													1
											}}
										>

											{
												this.renderStartMarkers(
													axisMax,
													distanceConfigs,
													baseOffset
												)
											}

										</div>


										<div
											style={{
												width:
													'80px',

												flexShrink:
													0
											}}
										/>

									</div>


									{
										this.renderTimeScale(
											axisMax,
											marks
										)
									}


									<div
										style={{
											position:
												'relative'
										}}
									>

										{
											this.renderGlobalGridLines(
												axisMax,
												marks
											)
										}


										{
											visibleParticipants.map(
												(
													item,
													index
												) =>
													this.renderParticipantRow(
														item,
														index,
														axisMax
													)
											)
										}

									</div>

								</div>

							</div>
						)
				}

			</div>
		);
	}

}


function mapStateToProps(
	state
) {

	const {
		participantList
	} =
		state.reducerRegisterTime;


	const {
		startedAt
	} =
		state.reducerTimer;


	const {
		competition,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset,

		categoryStartOffsets

	} =
		state.reducerRegisterInfo;


	return {

		participantList,

		startedAt,

		competition,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset,

		categoryStartOffsets
	};
}


export default connect(
	mapStateToProps
)(
	ParticipantVisualization
);



// WEBPACK FOOTER //
// ./src/containers/participant-visualization.js